module.exports = __webpack_public_path__ + "static/media/DBHelvethaicaXBdv3.2.660e3b8d.ttf";